class ComponentDispatch extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const name = this.getAttribute("name");
    const type = name.split(":").at(-1);
    
    this.addEventListener(type, (event) => {
      event.preventDefault();
      document.dispatchEvent(new Event(name));
    });
  }
}

customElements.define("component-dispatch", ComponentDispatch);
